module.exports = __webpack_public_path__ + "static/media/default-web.284f6680.jpg";